import { useState } from 'react'
import { Modal } from '@/components/ui/Modal'
import {
  CartIcon,
  CheckSquareIcon,
  CursorClickIcon,
  InfoIcon,
} from '@/components/ui/icons'

const STEPS = [
  { icon: CursorClickIcon, text: '1º Clique em um produto.' },
  { icon: CartIcon, text: '2º Faça a compra.' },
  {
    icon: CheckSquareIcon,
    text: '3º Marque o produto como comprado ou envie o link do produto no item "Adicionar compra".',
  },
]

/**
 * Botão de informação fixo no canto da tela + o diálogo "Como concorrer!".
 * É a explicação da mecânica do site; aparece em todas as páginas públicas.
 */
export function HowToWinDialog() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Como concorrer aos prêmios"
        title="Como concorrer"
        className="fixed bottom-6 right-4 z-30 flex size-10 items-center justify-center rounded bg-brand text-white shadow-pop transition-colors hover:bg-brand-dark md:bottom-auto md:top-1/2 md:-translate-y-1/2"
      >
        <InfoIcon className="size-6" />
      </button>

      <Modal open={open} onClose={() => setOpen(false)} title="Como concorrer!" className="max-w-sm">
        <ol className="flex flex-col gap-2.5">
          {STEPS.map(({ icon: Icon, text }) => (
            <li
              key={text}
              className="flex items-center justify-between gap-4 rounded bg-brand px-4 py-3.5 text-white"
            >
              <span className="text-sm font-medium leading-snug">{text}</span>
              <Icon className="size-6 shrink-0" />
            </li>
          ))}
        </ol>

        <p className="mt-5 text-center text-sm font-semibold text-ink">
          Pronto. Você já está participando!
        </p>

        <p className="mt-4 text-[13px] leading-relaxed text-ink-faint">
          Não encontrou o que procurava? Clique em um produto, procure o item desejado no
          site indicado, finalize a compra em até 24 horas e envie para a gente o link do
          produto adquirido. Assim, você já poderá concorrer.
        </p>
      </Modal>
    </>
  )
}
